import React from "react";
import "./bigMultiBar.css";
import { Bar } from "react-chartjs-2";
import Dropdown from "../Components/dropdown";

const BigMultiBar = ({
  options,
  monthsConsumption,
  monthsConsumption2,
  state,
  title,
  dropdown,
}) => {
  options = {
    responsive: true,

    plugins: {
      tooltip: {
        enabled: true, // <-- this option disables tooltips
      },
      legend: {
        display: false, // Hide the legend
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: { color: "#929292", font: { size: 10 }, padding: 5 },
        beginAtZero: true,
        grid: {
          display: false, // Extended vertical lines below x-axis only
          drawBorder: false,
        },
      },
      y: {
        stacked: true,
        ticks: { color: "#6C757D", font: { size: 12 } },
        beginAtZero: true,
        grid: {
          drawBorder: false, // <-- this removes y-axis line
        },
      },
    },
  };

  monthsConsumption = [
    200, 300, 269, 400, 600, 420, 333, 245, 500, 300, 400, 600,
  ];

  monthsConsumption2 = [
    400, 200, 169, 300, 500, 320, 233, 145, 400, 200, 300, 500,
  ];

  state = {
    data: {
      labels: [
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
      ],
      datasets: [
        {
          stack: "Stack 0",
          label: "Unresolved Queries",
          backgroundColor: "#FCB76D",
          borderColor: "#FCB76D",
          borderWidth: 1,
          data: monthsConsumption,
          borderRadius: 12, // Round the top edges of bars
          barThickness: 24, // Width of the bars
        },
        {
          stack: "Stack 0",
          label: "Resolved Queries ",
          backgroundColor: "#60B8EE",
          borderColor: "#60B8EE",
          borderWidth: 1,
          data: monthsConsumption2,
          borderRadius: 12, // Round the top edges of bars
          barThickness: 24, // Width of the bars
        },
      ],
    },
  };

  const balls = [
    { color: "#60B8EE", title: "Resolved Queries" },
    { color: "#FCB76D", title: "Unresolved Queries" },
  ];

  return (
    <div className="bigMultiBar">
      <div className="title">
        <span>{title}</span>
        {dropdown && <Dropdown data={dropdown} />}
      </div>
      <Bar height="210px" width="648px" options={options} data={state.data} />
      <div className="balls">
        {balls.map((ball, index) => (
          <div key={index} className="ball">
            <div className="color" style={{ backgroundColor: ball.color }}></div>
            <span>{ball.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BigMultiBar;
